import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, Dimmer, Icon } from 'semantic-ui-react';
import { toastr } from 'react-redux-toastr';
import { confirmAlert } from 'react-confirm-alert';
import { isMobile, isTablet } from 'react-device-detect';
import './savedCard.css';
import CardIcon from './component/CardIcon';



class SavedCard extends Component {
  static propTypes = {
    card: PropTypes.object
  };

  state = {
    hover: false
  };

  handleClick = () => {
    confirmAlert({
      title: 'Please confirm',
      message: `Are you sure, you want to delete ${this.props.card.cardMask} ?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteCard(this.props.card);
          }
        },
        {
          label: 'No',
          onClick: () => {
            toastr.error('Stored Cards', 'Operation cancelled by user');
          }
        }
      ]
    });
  };

  mouseOver = () => {
    this.setState({
      hover: true
    });
  };

  mouseOut = () => {
    this.setState({
      hover: false
    });
  };

  render() {
    const { card } = this.props;
    return (
      <div className="savedCard">
        <Card
          onClick={this.handleClick}
          onMouseOver={(isMobile || isTablet) ? () => {} : this.mouseOver}
          onMouseOut={(isMobile || isTablet) ? () => {} : this.mouseOut}
        >
          <Dimmer active={this.state.hover}>
            <Icon size="big" name="trash alternate outline" />
          </Dimmer>
          <Card.Content>
            <Card.Header>
              <div className="ellipsis cardIssuer">{card.cardIssuer}</div>{' '}
              <CardIcon card={card} />
            </Card.Header>
            <Card.Meta>{card.cardMask}</Card.Meta>
          </Card.Content>
        </Card>
      </div>
    );
  }
}

export default SavedCard;
